exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-components-___RadioList__radioList___3xF-c{padding-left:.6em}.web-components-___RadioList__radioList___3xF-c p{display:flex}.web-components-___RadioList__radioList___3xF-c input{width:1.2em}.web-components-___RadioList__radioList___3xF-c label{padding-left:.3em;flex:1}", ""]);

// exports
exports.locals = {
	"radioList": "web-components-___RadioList__radioList___3xF-c"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/components/RadioList.css
// module id = 1332
// module chunks = 0